import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
        <Link
          to="/"
          onClick={(e) => {
            const isOcrPage = document.body.classList.contains("ocr-active");

            if (isOcrPage) {
              e.preventDefault();
              window.dispatchEvent(new Event("APP_HOME_CLICK"));
            }
          }}
        >
          <Image
            src={require('../../../assets/images/pithias-tech.png')}
            alt="PITHIAS Extract"
            width={60}
            height={60}
            style={{
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid #1f3bb1',
              padding: '2px',
            }}
            draggable="false"
          />
        </Link>
      </h1>
    </div>
  );
}

export default Logo;